import React, { useEffect, useImperativeHandle, useRef, useState, useContext } from 'react';
import { Col, Row } from 'reactstrap';
import { useAuth0 } from '../../../../../auth0/reactAuth0Spa';
import { checkLoginForError, formatBearerToken } from '../../../../../Common.functions';
import { fetchDataAgnostic, fetchDataAuth0 } from '../../../../../Services/dataApi';
import CandidateList from '../../CandidateList';
import AdminMessageComposer from './AdminMessageComposer/AdminMessageComposer';
import { clone } from 'lodash';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import RezRateSideDrawer from 'Body/RezRATE/Common/RezRateSideDrawer/RezRateSideDrawer';
import { DepartmentContext } from '../../../../../DepartmentWrapper';

const AdminSendMessage = ({
  candidates,
  activeDepartment,
  interviewDates,
  setPageChanges,
  pageChanges,
  setCandidates,
  getCandidates,
  windowWidth,
}) => {
  const [availableTemplates, setAvailableTemplates] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedTemplateId, setSelectedTemplateId] = useState('placeholder');
  const [selectedCandidate, setSelectedCandidate] = useState();
  const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);
  const [initialSelectedCandidateIds, setInitialSelectedCandidateIds] = useState(null);
  const [departmentSettings, setDepartmentSettings] = useState(null);

  const [resetList, setResetList] = useState();

  const [isUpdating, setIsUpdating] = useState();

  const { getTokenSilently, loginWithRedirect } = useAuth0();
  const dContext = useContext(DepartmentContext);
  const history = useHistory();
  const { location } = history;
  const widthToSwitchToMobile = 900;
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    if (candidates && candidates.length > 0) {
      const searchParams = new URLSearchParams(location.search);
      const pk_Candidate = searchParams.get('pk_Candidate');
      const pks = searchParams.get('pks');

      if (pks) {
        // Handle multiple candidates from URL
        const pkArray = pks
          .split(',')
          .map((pk) => parseInt(pk.trim()))
          .filter((pk) => !isNaN(pk));
        const selectedIds = {};
        pkArray.forEach((pk) => {
          selectedIds[pk] = true;
        });
        setInitialSelectedCandidateIds(selectedIds);
        if (selectedCandidate == null) {
          setSelectedCandidate(candidates[0]);
        }
      } else if (pk_Candidate) {
        const candidateFromURL = candidates.find((candidate) => {
          return candidate.pk_Candidate == pk_Candidate;
        });

        setSelectedCandidate(candidateFromURL || candidates[0]);
        setInitialSelectedCandidateIds(null);
      } else {
        if (selectedCandidate == null) {
          setSelectedCandidate(candidates[0]);
        }
        setInitialSelectedCandidateIds(null);
      }
    }
  }, [candidates, location.search]);

  useEffect(() => {
    getTemplates();
    getDepartmentSettings();
  }, []);

  const getDepartmentSettings = () => {
    if (!activeDepartment || !dContext.season) return;

    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/settings',
          { pk_Department: activeDepartment.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            if (res.data && res.data[0]) {
              setDepartmentSettings(res.data[0]);
            }
          })
          .catch((err) => {
            console.error('Error fetching department settings:', err);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getTemplates = (id = null, cb) => {
    getTokenSilently()
      .then((token) => {
        fetchDataAuth0(
          'department/readCommunicationTemplates',
          { pk_Department: activeDepartment.pk_Department },
          formatBearerToken(token),
        )
          .then((result) => {
            const newData = result.data || [];

            if (newData) {
              newData.sort(function(a, b) {
                var textA = a.Title.toUpperCase();
                var textB = b.Title.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
              });
            }

            setAvailableTemplates(newData);

            if (id) {
              // if a template was just added select that template from the options
              setSelectedTemplateId(id);
              getTemplateById(id);
            } else if (selectedTemplate) {
              getTemplateById(selectedTemplate.pk_CommunicationTemplate);
            } else {
              console.log('no selected template');
            }

            if (cb) {
              cb();
            }
          })
          .catch((err) => {
            if (cb) {
              cb(err);
            }
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getTemplateById = (value) => {
    setSelectedTemplateId(value);
    // if they choose the placeholder option just set the selected template to null
    if (value === 'placeholder') {
      setSelectedTemplate(null);
      return;
    }

    setIsUpdating(true);
    getTokenSilently().then((token) => {
      fetchDataAgnostic(
        'department/readCommunicationTemplate',
        { pk_Department: activeDepartment.pk_Department, pk_CommunicationTemplate: value },
        formatBearerToken(token),
      )
        .then((result) => {
          setIsUpdating(false);
          setSelectedTemplate(result.data);
        })
        .catch((err) => {
          setIsUpdating(false);
          checkLoginForError({ err, loginWithRedirect });
        });
    });
  };

  if (!activeDepartment) {
    return <div />;
  }

  const renderCandidateList = (options) => (
    <CandidateList
      height={`calc(100vh - 240px)`}
      multiselect={true}
      interviewDates={interviewDates}
      candidates={candidates}
      pk_Department={activeDepartment.pk_Department}
      setSelectedCandidate={setSelectedCandidate}
      selectedCandidate={selectedCandidate}
      showTagFilter={true}
      options={options}
      initialSelectedCandidateIds={initialSelectedCandidateIds}
      setResetList={(newResetList) => {
        setResetList(() => {
          return newResetList;
        });
      }}
      updateParentValues={(newSelectedCandidateIDs) => {
        const selectedActual = [];
        Object.keys(newSelectedCandidateIDs).forEach((key) => {
          if (newSelectedCandidateIDs[key]) {
            selectedActual.push(parseInt(key));
          }
        });
        setSelectedCandidateIds(selectedActual);
      }}
    />
  );

  if (windowWidth < widthToSwitchToMobile) {
    // Mobile: show button to open drawer, drawer contains CandidateList
    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <RezRateSideDrawer
          isOpen={drawerOpen}
          setIsOpen={setDrawerOpen}
          toggle={() => {
            setDrawerOpen(!drawerOpen);
          }}
          options={{ width: '350px' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', height: `calc(100vh - 40px)` }}>
            {renderCandidateList({ isDark: true })}
          </div>
        </RezRateSideDrawer>
        <div
          style={{
            padding: 0,
            margin: 5,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            overflowY: 'clip',
            minWidth: 320,
            height: `calc(100vh - 270px)`,
          }}
          className="card shadow bg-light"
        >
          <AdminMessageComposer
            activeDepartment={activeDepartment}
            availableTemplates={availableTemplates}
            candidates={candidates}
            getCandidates={getCandidates}
            getTemplateById={getTemplateById}
            getTemplates={getTemplates}
            isUpdating={isUpdating}
            pageChanges={pageChanges}
            selectedCandidate={selectedCandidate}
            selectedCandidateIds={selectedCandidateIds}
            selectedTemplate={selectedTemplate}
            selectedTemplateId={selectedTemplateId}
            setCandidates={setCandidates}
            setPageChanges={setPageChanges}
            setSelectedCandidateIds={setSelectedCandidateIds}
            setSelectedTemplate={setSelectedTemplate}
            setSelectedTemplateId={setSelectedTemplateId}
            windowWidth={windowWidth}
            interviewDates={interviewDates}
            departmentSettings={departmentSettings}
            resetList={() => {
              if (resetList) {
                resetList();
              } else {
                console.log('no reset list func');
              }
            }}
          />
        </div>
      </div>
    );
  }

  // Desktop: original layout
  return (
    <div style={{ display: 'flex', flexDirection: 'row', overflowX: 'auto' }}>
      <div
        style={{
          padding: 10,
          paddingTop: 5,
          margin: 5,
          display: 'flex',
          flexDirection: 'column',
          width: '40%',
          minWidth: 260,
          height: `calc(100vh - 270px)`,
        }}
        className="card shadow bg-light"
      >
        {renderCandidateList()}
      </div>
      <div
        style={{
          padding: 0,
          margin: 5,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          overflowY: 'clip',
          minWidth: 620,
          height: `calc(100vh - 270px)`,
        }}
        className="card shadow bg-light"
      >
        <AdminMessageComposer
          activeDepartment={activeDepartment}
          availableTemplates={availableTemplates}
          candidates={candidates}
          getCandidates={getCandidates}
          getTemplateById={getTemplateById}
          getTemplates={getTemplates}
          isUpdating={isUpdating}
          pageChanges={pageChanges}
          selectedCandidate={selectedCandidate}
          selectedCandidateIds={selectedCandidateIds}
          selectedTemplate={selectedTemplate}
          selectedTemplateId={selectedTemplateId}
          setCandidates={setCandidates}
          setPageChanges={setPageChanges}
          setSelectedCandidateIds={setSelectedCandidateIds}
          setSelectedTemplate={setSelectedTemplate}
          setSelectedTemplateId={setSelectedTemplateId}
          windowWidth={windowWidth}
          interviewDates={interviewDates}
          departmentSettings={departmentSettings}
          resetList={() => {
            if (resetList) {
              resetList();
            } else {
              console.log('no reset list func');
            }
          }}
        />
      </div>
    </div>
  );
};

export default AdminSendMessage;
